import { nanoid } from "@reduxjs/toolkit";

import shoes1 from "../../../../assets/MenShoes/walkingShoes/shoes1.png";
import shoes11 from "../../../../assets/MenShoes/walkingShoes/shoes11.png";
import shoes12 from "../../../../assets/MenShoes/walkingShoes/shoes12.png";
import shoes13 from "../../../../assets/MenShoes/walkingShoes/shoes13.png";

import shoes2 from "../../../../assets/MenShoes/walkingShoes/shoes2.png";
import shoes21 from "../../../../assets/MenShoes/walkingShoes/shoes21.png";
import shoes22 from "../../../../assets/MenShoes/walkingShoes/shoes22.png";
import shoes23 from "../../../../assets/MenShoes/walkingShoes/shoes23.png";

import shoes3 from "../../../../assets/MenShoes/walkingShoes/shoes3.png";
import shoes31 from "../../../../assets/MenShoes/walkingShoes/shoes31.png";
import shoes32 from "../../../../assets/MenShoes/walkingShoes/shoes32.png";
import shoes33 from "../../../../assets/MenShoes/walkingShoes/shoes33.png";

import shoes4 from "../../../../assets/MenShoes/walkingShoes/shoes4.png";
import shoes41 from "../../../../assets/MenShoes/walkingShoes/shoes41.png";
import shoes42 from "../../../../assets/MenShoes/walkingShoes/shoes42.png";
import shoes43 from "../../../../assets/MenShoes/walkingShoes/shoes43.png";

import shoes5 from "../../../../assets/MenShoes/walkingShoes/shoes5.png";
import shoes51 from "../../../../assets/MenShoes/walkingShoes/shoes51.png";
import shoes52 from "../../../../assets/MenShoes/walkingShoes/shoes52.png";
import shoes53 from "../../../../assets/MenShoes/walkingShoes/shoes53.png";

import shoes6 from "../../../../assets/MenShoes/walkingShoes/shoes6.png";
import shoes61 from "../../../../assets/MenShoes/walkingShoes/shoes61.png";
import shoes62 from "../../../../assets/MenShoes/walkingShoes/shoes62.png";
import shoes63 from "../../../../assets/MenShoes/walkingShoes/shoes63.png";

import shoes7 from "../../../../assets/MenShoes/walkingShoes/shoes7.png";
import shoes71 from "../../../../assets/MenShoes/walkingShoes/shoes71.png";
import shoes72 from "../../../../assets/MenShoes/walkingShoes/shoes72.png";
import shoes73 from "../../../../assets/MenShoes/walkingShoes/shoes73.png";

import shoes8 from "../../../../assets/MenShoes/walkingShoes/shoes8.png";
import shoes81 from "../../../../assets/MenShoes/walkingShoes/shoes81.png";
import shoes82 from "../../../../assets/MenShoes/walkingShoes/shoes82.png";
import shoes83 from "../../../../assets/MenShoes/walkingShoes/shoes83.png";

import shoes9 from "../../../../assets/MenShoes/walkingShoes/shoes9.png";
import shoes91 from "../../../../assets/MenShoes/walkingShoes/shoes91.png";
import shoes92 from "../../../../assets/MenShoes/walkingShoes/shoes92.png";
import shoes93 from "../../../../assets/MenShoes/walkingShoes/shoes93.png";

export const MenWalkingShoesData = [
  {
    id: nanoid(),
    image: shoes1,
    title: "Grand Slipon Men's Sneakers",
    price: 2269,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Dark Slate-PUMA White",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Featuring a classic silhouette, if you are one of those who likes their style to be muted and sophisticated at the same time, then",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Featuring a classic silhouette, if you are one of those who likes their style to be muted and sophisticated at the same time, then the Grand Slip-On Men's Shoes is the one for you. This pair will only elevate your casual style",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point: "Mesh Upper",
      },
      {
        id: nanoid(),
        point: "PUMA Wordmark at lateral side",
      },
      {
        id: nanoid(),
        point: "PUMA Cat logo at tongue",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "MOCHIKO SHOES PRIVATE LIMITED",
      },

      {
        id: nanoid(),
        point:
          "IN UTTRAKHAND KHASRA NO 3914, MOUZA MAZRI GRANT, LAL TAPPER INDUSTRIAL AREA, NH-72, 248140 DEHRADUN",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes1,
      },
      {
        id: nanoid(),
        imgCard: shoes11,
      },
      {
        id: nanoid(),
        imgCard: shoes12,
      },
      {
        id: nanoid(),
        imgCard: shoes13,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes2,
    title: "SOFTRIDE Rift Knit One8 Unisex Running Shoes",
    price: 3359,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA Black-PUMA White",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "PUMA's SOFTRIDE technology represents an advancement in footwear comfort. It incorporates our softest foam, designed to",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "The SOFTRIDE Rift Knit One8 Unisex Running Shoes is crafted to offer smooth leisure. The SOFTRIDE midsole offers plush comfort. The mesh upper and traction outsole complemented with the TPU clip provides impeccable grip and stability",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 12 mm",
      },
      {
        id: nanoid(),
        point: "Breathable, lightweight knitted upper",
      },
      {
        id: nanoid(),
        point: "one8 insignia at the tongue,heel & footbed",
      },
      {
        id: nanoid(),
        point: "Full lace closure for secure fit",
      },
      {
        id: nanoid(),
        point: "Zoned rubber midsole provides versatile grip and traction",
      },
      {
        id: nanoid(),
        point: "Asymmetrical padded collar opening",
      },
      {
        id: nanoid(),
        point: "SOFTRIDE foam midsole",
      },
      {
        id: nanoid(),
        point: "Ideal for Road & Treadmill Running",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "Athena Viet Nam Footwear Company Limited",
      },

      {
        id: nanoid(),
        point:
          "FVNAT Dong Doai Village, Yen Lam Com mune , Yen Mo District,  Ninh Binh province",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes2,
      },
      {
        id: nanoid(),
        imgCard: shoes21,
      },
      {
        id: nanoid(),
        imgCard: shoes22,
      },
      {
        id: nanoid(),
        imgCard: shoes23,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes3,
    title: "ST Activate Unisex Sneakers",
    price: 2239,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Puma Black-Puma White",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Lightweight comfort meets laid-back street style in the ST Activate. A sleek breathable mesh upper combines with a fashion",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Lightweight comfort meets laid-back street style in the ST Activate. A sleek breathable mesh upper combines with a fashion-forward, lightweight EVA midsole and comfortable sock-like structure so you can float through your day.",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 0 mm",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "ALERON VIET NAM FOOTWEAR LIMITED",
      },

      {
        id: nanoid(),
        point:
          "FVNEC THANH HOA PROVINCE HOANG LONG INDUSTRIAL ZONE TAO XUYEN WARD CHATHAM ROAD SOUTH",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes3,
      },
      {
        id: nanoid(),
        imgCard: shoes31,
      },
      {
        id: nanoid(),
        imgCard: shoes32,
      },
      {
        id: nanoid(),
        imgCard: shoes33,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes4,
    title: "ST Activate Unisex Sneakers",
    price: 2239,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Puma Black-Puma White",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Lightweight comfort meets laid-back street style in the ST Activate. A sleek breathable mesh upper combines with a fashion",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Lightweight comfort meets laid-back street style in the ST Activate. A sleek breathable mesh upper combines with a fashion-forward, lightweight EVA midsole and comfortable sock-like structure so you can float through your day.",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Platform",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 0 mm",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "ALERON VIET NAM FOOTWEAR LIMITED",
      },

      {
        id: nanoid(),
        point:
          "FVNEC THANH HOA PROVINCE HOANG LONG INDUSTRIAL ZONE TAO XUYEN WARD CHATHAM ROAD SOUTH",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes4,
      },
      {
        id: nanoid(),
        imgCard: shoes41,
      },
      {
        id: nanoid(),
        imgCard: shoes42,
      },
      {
        id: nanoid(),
        imgCard: shoes43,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes5,
    title: "SOFTRIDE Rift Bold Men's Slip-On Walking Shoes",
    price: 3439,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Puma Black-Puma White",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "PUMA's SOFTRIDE technology represents an advancement in footwear comfort. It incorporates our softest foam, designed to",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "For the confident and determined walker, this edition of the SOFTRIDE Rift Bold Men's Slip-On Walking Shoes offers ultra-cushioned comfort and unbeatable traction alongside bold stand-out branding and an avant-garde silhouette. A modern slip-on construction and alternative lace design meets SOFTRIDE and SoftFoam+ technology, finished with a contrast PUMA Wordmark across the side.",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 12 mm",
      },
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point: "Slip-on bootie construction",
      },
      {
        id: nanoid(),
        point: "SOFTRIDE midsole for extreme cushioning and all-day comfort",
      },
      {
        id: nanoid(),
        point: "Zoned rubber outsole for traction",
      },
      {
        id: nanoid(),
        point: "PUMA Wordmark at lateral side",
      },
      {
        id: nanoid(),
        point: "PUMA Cat Logo at toe, tongue and heel",
      },
      {
        id: nanoid(),
        point: "Ideal for Road & Treadmill Running",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "ALERON VIET NAM FOOTWEAR LIMITED",
      },

      {
        id: nanoid(),
        point:
          "FVNEC THANH HOA PROVINCE HOANG LONG INDUSTRIAL ZONE TAO XUYEN WARD CHATHAM ROAD SOUTH",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes5,
      },
      {
        id: nanoid(),
        imgCard: shoes51,
      },
      {
        id: nanoid(),
        imgCard: shoes52,
      },
      {
        id: nanoid(),
        imgCard: shoes53,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes6,
    title: "SOFTRIDE Premier So Splatter Men's Running Shoes",
    price: 3709,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "CASTLEROCK-Puma Black-Lime Squeeze",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "PUMA's SOFTRIDE technology represents an advancement in footwear comfort. It incorporates our softest foam, designed to",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Softness goes slip-on in these striking, splatter-print running shoes. Built with our celebrated SOFTRIDE comfort footbed and SoftFoam+ sockliner, the Premier is uniquely comfortable and relentlessly stylish",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 5 mm",
      },
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point: "Slip-on bootie construction",
      },
      {
        id: nanoid(),
        point: "SOFTRIDE midsole for extreme cushioning and all-day comfort",
      },
      {
        id: nanoid(),
        point: "Zoned rubber outsole for traction",
      },
      {
        id: nanoid(),
        point: "PUMA Wordmark at lateral side",
      },
      {
        id: nanoid(),
        point: "PUMA Cat Logo at toe, tongue and heel",
      },
      {
        id: nanoid(),
        point: "Ideal for Road & Treadmill Running",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "ALERON VIET NAM FOOTWEAR LIMITED",
      },

      {
        id: nanoid(),
        point:
          "FVNEC THANH HOA PROVINCE HOANG LONG INDUSTRIAL ZONE TAO XUYEN WARD CHATHAM ROAD SOUTH",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes6,
      },
      {
        id: nanoid(),
        imgCard: shoes61,
      },
      {
        id: nanoid(),
        imgCard: shoes62,
      },
      {
        id: nanoid(),
        imgCard: shoes63,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes7,
    title: "Cave V2 Men's Sneakers",
    price: 2279,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Quarry-Fizzy Lime",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "PUMA's SOFTRIDE technology represents an advancement in footwear comfort. It incorporates our softest foam, designed to",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Slip on our SOFTRIDE Clean V2 Running Shoes and be ready to run in a matter of seconds. With medium cushioning level and featuring both SOFTRIDE and SOFTFOAM+, this pair has got all the comfort bases covered so you can focus on beating your personal best.",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 12 mm",
      },
      {
        id: nanoid(),
        point: "Low boot",
      },
      {
        id: nanoid(),
        point: "Slip-on bootie construction",
      },
      {
        id: nanoid(),
        point: "SOFTRIDE midsole for extreme cushioning and all-day comfort",
      },
      {
        id: nanoid(),
        point: "Zoned rubber outsole for traction",
      },
      {
        id: nanoid(),
        point: "PUMA Wordmark at lateral side",
      },
      {
        id: nanoid(),
        point: "PUMA Cat Logo at toe, tongue and heel",
      },
      {
        id: nanoid(),
        point: "Ideal for Road & Treadmill Running",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "ALERON VIET NAM FOOTWEAR LIMITED",
      },

      {
        id: nanoid(),
        point:
          "FVNEC THANH HOA PROVINCE HOANG LONG INDUSTRIAL ZONE TAO XUYEN WARD CHATHAM ROAD SOUTH",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes7,
      },
      {
        id: nanoid(),
        imgCard: shoes71,
      },
      {
        id: nanoid(),
        imgCard: shoes72,
      },
      {
        id: nanoid(),
        imgCard: shoes73,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes8,
    title: "SOFTRIDE Clean V2 Men's Running Shoes",
    price: 3999,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA Black-PUMA Silver",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "The Cave V2 Men's Sneakers will take your game to the next level with the ultimate fusion of classic style and modern design! With a",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "The Cave V2 Men's Sneakers will take your game to the next level with the ultimate fusion of classic style and modern design! With a sleek textile upper and classic PUMA branding, these sneakers are sure to turn heads on and off the court. The rubber outsole provides superior traction, while the lightweight midsole ensures maximum comfort and support.",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Platform",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 0 mm",
      },
      {
        id: nanoid(),
        point: "Synthetic & Mesh Upper provides breathability & durabilty",
      },
      {
        id: nanoid(),
        point: "Rubber outsole",
      },
      {
        id: nanoid(),
        point: "EVA midsole",
      },
      {
        id: nanoid(),
        point: "low boot construction with lace closure",
      },
      {
        id: nanoid(),
        point: "PUMA Logo",
      },
      {
        id: nanoid(),
        point: "Rubber Outsole for traction",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "MOCHIKO SHOES PRIVATE LIMITED",
      },

      {
        id: nanoid(),
        point:
          "IN UTTRAKHAND KHASRA NO 3914, MOUZA MAZRI GRANT, LAL TAPPER INDUSTRIAL AREA, NH-72 248140 DEHRADUN",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes8,
      },
      {
        id: nanoid(),
        imgCard: shoes81,
      },
      {
        id: nanoid(),
        imgCard: shoes82,
      },
      {
        id: nanoid(),
        imgCard: shoes83,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes9,
    title: "Comp Men's Sneakers",
    price: 2279,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Intense Blue-Puma White",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Elevate your everyday style with the Comp Men's Shoes. Featuring sophisticated colours and minimalistic design, these shoes can be",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Elevate your everyday style with the Comp Men's Shoes. Featuring sophisticated colours and minimalistic design, these shoes can be paired with anything and it will only make your look better. The subtle PUMA branding is the the cherry on top.",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Mesh upper for breathability",
      },
      {
        id: nanoid(),
        point: "PUMA Formstripe on lateral side",
      },
      {
        id: nanoid(),
        point: "PUMA Cat logo at medial side and tongue",
      },
      {
        id: nanoid(),
        point: "PUMA Wordmark at counter pull tab",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "SSIPL RETAIL LIMITED",
      },

      {
        id: nanoid(),
        point:
          "IN SIRMOUR VILL-MEHRUWALA,PO-BHAGANI, TEHSIL-PAONTASAHIB,DISTT-SIRMO HP 173025 PAONTASAHIB",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes9,
      },
      {
        id: nanoid(),
        imgCard: shoes91,
      },
      {
        id: nanoid(),
        imgCard: shoes92,
      },
      {
        id: nanoid(),
        imgCard: shoes93,
      },
    ],
  },
];
